import React from 'react';
import { getIncomeSource, getClientId, closeVipSubscribeDialog } from '@/utils/vip';
import InfoIcon from '@/assets/image/vip/info-icon.png';
import Modal from '../modal';
import { useAtom } from 'jotai';
import { visibleBindPhoneAtom } from '@/store';

import styles from './index.module.css';

const BindPhone = () => {
  const [, setVisibleBindPhone] = useAtom(visibleBindPhoneAtom);

  const handleJump = () => {
    // 未绑定手机号
    let prefix = process.env.REACT_APP_ENV;

    if (process.env.REACT_APP_ENV === 'release') {
      prefix = '';
    }
    // client_callback=0,绑定成功后直接跳回用户主页
    const jumpUrl = `https://${prefix}account.meitu.com/#!/client/dispatch?client_id=${getClientId()}&action=bind_phone&client_callback=0&copyright=hide`;

    if (getIncomeSource() !== 'MTXX-WEB') {
      window.location.href = jumpUrl;
    } else {
      window.top?.open(jumpUrl);
      handleCancel();
    }
  };

  const handleCancel = () => {
    setVisibleBindPhone(false);
    closeVipSubscribeDialog({
      success: true,
    });
  };

  return (
    <Modal style={{ width: '320px' }} visible={true} onClose={handleCancel}>
      <div className={styles.body}>
        <div className={styles.modalTitel}>
          <img className={styles.modalIcon} src={InfoIcon} alt="" />
          <span>绑定手机号</span>
        </div>
        <div className={styles.modalDesc}>
          为了保障您的会员体验，
          <br />
          请先绑定一个常用手机号~
        </div>
        <div className={styles.modalFooter}>
          <div className={styles.cancel} onClick={handleCancel}>
            跳过
          </div>
          <div className={styles.confirm} onClick={handleJump}>
            前往绑定
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default React.memo(BindPhone);
